export class QFileWidget {
  constructor(el, mimetypes, messages, uploadQueue, Emitter, maxSize) {
    let index = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    this.indexFilefield = index;
    this.uploadQueue = uploadQueue;
    this.$dropzoneContent = el;
    this.$dropzoneContent.dataset.active = "1";
    this.inputId = el.dataset.input_id || false;
    this.loaderNameId = el.dataset.loader_name_id || false;
    this.listNameId = el.dataset.list_name_id || false;
    this.cartNameId = el.dataset.cart_name_id || false;
    this.massageId = el.dataset.message_id || false;
    this.fileDropzoneType = el.dataset.dropzone_type || "0";
    this.maxCountFiles = el.dataset.max_count_files || 1;
    // this.deleteFiles = [];
    this.files = [];
    this.maxSize = maxSize;
    this.mimtypes = mimetypes;
    this.Emitter = Emitter;
    this.messages = messages;
  }
  toHtml() {
    this.$dropzoneContent.innerHTML = `
      <div class="info-bar">
        <div class="size-files-box">
          <span id="${this.inputId}_count-files">
            ${this.files.length}/${this.maxCountFiles} ${this.messages.files}
          </span>
          <span
            class="size-files"
            id="${this.inputId}_size-files">
          </span>
        </div>
        <button
          class="qform-file-clear-btn"
          id="${this.inputId}_clear-btn"
          data-clear="full">
          ${this.messages.clear}
        </button>
      </div>
      <ul class="file-list" id="${this.listNameId}">
        ${this.getFileListHTML(this.files)}
      </ul>
    `;
    this.$filesCounter = document.getElementById(`${this.inputId}_count-files`);
    this.$fileList = document.getElementById(this.listNameId);
    this.$btnClearAll = document.getElementById(`${this.inputId}_clear-btn`);
    this.$btnClearAll.setAttribute("disabled", true);
    this.computeOverallFilesSize();
    this.addCloseAllBtnListener();
    this.addCloseBtnsListeners(this.files);
    this.getFilePreview();
  }

  //создание разметки для списка загружаемых файлов
  getFileListHTML(files) {
    let str = "";
    if (this.fileDropzoneType === "0") {
      for (let i = 0; i < files.length; i++) {
        str += `
        <li
          class="file-item-stack"
          id="${this.cartNameId}_${files[i].id}"
          data-size="${files[i].size || 0}"
          data-id="${files[i].id}"
        >
          <div class="file-list__img">
            <div class="file-list__progress" id="${this.loaderNameId}_${files[i].id}">
              <div class="progress__value animate">⏳</div>
              <div class="progress__scale"></div>
            </div>
            <img id="${this.inputId}_prev_${files[i].id}" alt>
            <div id="${this.inputId}_prev_ext_${files[i].id}" class="qform-preview-extension"></div>
          </div>
          <span class="file-list__name" id="filename_${files[i].id}">${files[i].name.replace(/\.[^.]+$/, "")} <br>
            <span class="file-list__ext" id="filesize_${files[i].id}">
            (${this.formatSize(files[i].size)})
            </span>
          </span>
          <div
            class="file-list__close"
            id="${this.inputId}_clear_${files[i].id}"
            data-clear="${files[i].id}"
            >
          </div>
        </li>`;
      }
    } else {
      for (let i = 0; i < files.length; i++) {
        str += `
        <li
          class="file-item-cart"
          id="${this.cartNameId}_${files[i].id}"
          data-size="${files[i].size || 0}"
          data-id="${files[i].id}"
        >
          <span class="file-list__name" id="filename_${files[i].id}">
              ${files[i].name.replace(/\.[^.]+$/, "")}
          </span>
          <span class="file-list__ext" id="filesize_${files[i].id}">
            ${files[i].name.split(".").pop()}
          </span>
          <div class="file-list__progress" id="${this.loaderNameId}_${files[i].id}">
              <div class="progress__value">⏳</div>
              <div class="progress__scale"></div>
            </div>
          <div
            class="file-list__close"
            id="${this.inputId}_clear_${files[i].id}"
            data-clear="${files[i].id}"
          >
            ×
          </div>
        </li>`;
      }
    }
    return str;
  }

  //событие изменения количества файлов в поле ввода (вызывается при добавлении - удалении)
  change() {
    if (this.$inputFile.dataset.reset === "1") {
      this.$inputFile.dataset.reset = "0";
      this.files = [];
    }
    if (this.$inputFile.files.length === 0 && this.files.length === 0) {
      this.$dropzoneContent.style.display = "none";
    } else {
      this.$dropzoneContent.style.display = "block";
      if (this.$inputFile.files.length > 0 && this.files.length === 0) {
        this.files = this.formFilesList();
        this.toHtml();
      } else {
        const newFiles = this.formFilesList();
        this.files = this.files.concat(newFiles);
        this.$fileList.insertAdjacentHTML("beforeend", this.getFileListHTML(newFiles));
        this.addCloseBtnsListeners(newFiles);
        this.computeOverallFilesSize();
        this.setFilesCount();
        this.getFilePreview();
      }
      this.checkFiles();
      this.emitUploadButtonActiveState();
    }
    this.emitFilesCount();
    this.Emitter.emit("Change:field", {});
  }

  //формирование массива загруженных файлов
  formFilesList() {
    const files = [];
    for (let i = 0; i < this.$inputFile.files.length; i++) {
      if (!this.files.find(elem => elem.name === this.$inputFile.files[i].name)) {
        files.push({
          name: this.$inputFile.files[i].name,
          size: this.$inputFile.files[i].size,
          file: this.$inputFile.files[i],
          extension: this.$inputFile.files[i].name.split(".").pop(),
          id: String(this.$inputFile.files[i].lastModified) + String(this.$inputFile.files[i].size) + i
        });
      }
    }
    return files;
  }
  checkFiles() {
    this.files.forEach(elem => {
      if (!elem.file.isValidFileSize || !elem.file.isValidMimtype) {
        this.setFileInfoAttentionColor(elem.id);
        this.showCloseFileBtn(elem.id);
        this.removeFileLoader(elem.id);
      }
    });
  }

  /**
   * @param e {MouseEvent}
   * */
  clearFile(e) {
    e.preventDefault();
    if (e.target.dataset.clear) {
      let clearId = e.target.dataset.clear;
      // this.deleteFiles = [];
      //если нажали на очистку списка загруженных файлов
      if (clearId === "full") {
        this.uploadQueue = [];
        // this.files.forEach((file) => {
        //   this.deleteFiles.push(file.name);
        // });
        // this.setDeletedFile();
        this.files = [];
        this.$inputFile.value = "";
        this.$inputFile.dispatchEvent(new Event("change"));
        this.Emitter.emit(`full-cleared-${this.inputId}`);
        this.emitUploadButtonActiveState();
        /* this.getCountFiles(); */
        //если удалили одно из изображений
        this.emitFilesCount();
      } else {
        const fileToDelete = this.files.find(file => file.id === clearId);
        const fileToDeleteInList = document.querySelector(`#${this.cartNameId}_${fileToDelete.id}`);
        fileToDeleteInList?.remove();
        this.$inputFile.value = "";
        // this.deleteFiles.push(fileToDelete.name);
        this.files.splice(this.files.findIndex(file => file === fileToDelete), 1);
        if (this.files.length) {
          this.computeOverallFilesSize();
          this.setFilesCount();
        } else {
          this.$dropzoneContent.style.display = "none";
          this.Emitter.emit(`full-cleared-${this.inputId}`);
        }
        this.emitUploadButtonActiveState();
        this.Emitter.emit(`deleted-${this.inputId}`, {
          id: fileToDelete.id,
          filename: fileToDelete.name,
          size: fileToDelete.size
        });
        this.emitFilesCount();
      }
    }
  }
  getFilePreview() {
    for (let i = 0; i < this.files.length; i++) {
      let imgPreview = document.getElementById(`${this.inputId}_prev_${this.files[i].id}`);
      let imgExtPreview = document.getElementById(`${this.inputId}_prev_ext_${this.files[i].id}`);
      if (this.files[i].file.isValidMimtype) {
        const reader = new FileReader();
        reader.readAsDataURL(this.files[i].file);
        reader.onload = () => {
          if (imgPreview) {
            imgPreview.onerror = e => {
              e.target.hidden = true;
              if (imgExtPreview) {
                imgExtPreview.innerHTML = this.files[i].extension;
                imgExtPreview.classList.add(this.files[i].extension);
              }
            };
            imgPreview.setAttribute("src", reader.result);
          }
        };
        reader.onerror = e => {
          console.error(e);
        };
      } else {
        //если отображение в виде списка
        if (this.fileDropzoneType === 0) {
          if (imgPreview) {
            imgPreview.classList.add("qform-file-error");
          }
        } else {
          //если отображение в виде карточки
          const $itemCard = document.getElementById(`${this.cartNameId}_${this.files[i].id}`);
          $itemCard.classList.add("qform-file-error");
        }
        this.setFileInfoAttentionColor(this.files[i].id);
        this.Emitter.emit("loaded", this.files[i].id);
      }
    }
  }
  setFileInfoAttentionColor(fileId) {
    let filename = document.getElementById(`filename_${fileId}`);
    let filesize = document.getElementById(`filesize_${fileId}`);
    if (filename) {
      filename.classList.add("qform-file-error");
    }
    if (filesize) {
      filesize.classList.add("qform-file-error");
    }
  }
  formatSize(length) {
    let i = 0,
      type = [this.messages.b, this.messages.kb, this.messages.mb, this.messages.gb, this.messages.tb, this.messages.pb];
    while (length / 1000 | 0 && i < type.length - 1) {
      length /= 1024;
      i++;
    }
    return length.toFixed(2) + " " + type[i];
  }

  //подсчет общего веса файлов в списке
  computeOverallFilesSize() {
    let size = 0;
    for (let i = 0; i < this.files.length; i++) {
      size += this.files[i].size;
    }
    document.getElementById(`${this.inputId}_size-files`).innerHTML = this.formatSize(size);
  }
  setFilesCount() {
    this.$filesCounter.innerText = `${this.files.length}/${this.maxCountFiles} ${this.messages.files}`;
  }
  addListener() {
    this.$inputFile.addEventListener("change", this.change.bind(this));
  }

  //добавление обработчиков для добавленных в список файлов
  addCloseBtnsListeners(files) {
    for (let i = 0; i < files.length; i++) {
      const btnClear = document.getElementById(`${this.inputId}_clear_${files[i].id}`);
      if (btnClear) {
        btnClear.addEventListener("click", e => this.clearFile(e));
        btnClear.style.display = "none";
      }
    }
  }

  //добавление обработчика на кнопку "очистить"
  addCloseAllBtnListener() {
    if (this.$btnClearAll) {
      this.$btnClearAll.addEventListener("click", this.clearFile.bind(this));
      this.Emitter.subscribe(`unlock-clear-all-${this.inputId}`, () => {
        this.$btnClearAll.removeAttribute("disabled");
      });
    }
  }
  emitUploadButtonActiveState() {
    this.Emitter.emit(`toggle-upload-btn-${this.inputId}`, this.files.length >= this.maxCountFiles);
  }
  emitFilesCount() {
    this.Emitter.emit(`files-count-${this.inputId}`, this.files.length);
  }
  removeFileLoader(id) {
    const progressBarEl = this.$fileList?.querySelector(`li[data-id="${id}"] .file-list__progress`);
    if (progressBarEl) {
      progressBarEl.style.display = "none";
    }
  }
  showCloseFileBtn(fileId) {
    const closeBtn = document.getElementById(`${this.inputId}_clear_${fileId}`);
    if (closeBtn) {
      closeBtn.style.display = "block";
    }
  }
  init() {
    if (this.inputId) {
      this.$inputFile = document.getElementById(this.inputId);
      if (this.$inputFile) {
        this.addListener();
        this.Emitter.subscribe("loaded", fileId => {
          this.removeFileLoader(fileId);
          this.showCloseFileBtn(fileId);
        });
        this.Emitter.subscribe("server-error", filename => {
          const errorFile = this.files.find(file => file.name === filename);
          const errorFileId = errorFile?.id;
          this.setFileInfoAttentionColor(errorFileId);
          this.showCloseFileBtn(errorFileId);
          this.removeFileLoader(errorFileId);
        });
        this.Emitter.subscribe("network-error", () => {
          this.files.forEach(file => {
            this.setFileInfoAttentionColor(file.id);
            this.showCloseFileBtn(file.id);
            this.removeFileLoader(file.id);
          });
        });
        this.Emitter.subscribe("progress", data => {
          const progressBarEl = this.$fileList?.querySelector(`li[data-id="${data.id}"] .file-list__progress`);
          if (progressBarEl) {
            const progressBarValueEl = progressBarEl?.querySelector(".progress__value");
            const progressBarScaleEl = progressBarEl.querySelector(".progress__scale");
            progressBarValueEl.classList.remove("animate");
            progressBarValueEl.innerHTML = Math.floor(data.progress) + "%";
            progressBarScaleEl.style.height = data.progress + "%";
          }
        });
      }
    }
  }
}